/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_TitleInputs */



/**
* | output |
* | --- |
* | "Style Guide Manager" |
*
* @param {Style_Guide_Manager_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_title = /** @type {((inputs?: Style_Guide_Manager_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gestionnaire de guide de style")
	if (locale === "de") return /** @type {LocalizedString} */ ("Styleguide-Manager")
	if (locale === "it") return /** @type {LocalizedString} */ ("Responsabile della guida di stile")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Менеджер руководства по стилю")
	if (locale === "es") return /** @type {LocalizedString} */ ("Administrador de guías de estilo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("样式指南管理器")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スタイルガイドマネージャー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्टाइल गाइड प्रबंधक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gerente de Guia de Estilo")
	return /** @type {LocalizedString} */ ("Style Guide Manager")
});